export const getCurrentChurchSelector = state => state.churches.current;
